@import (reference) '../../../../../constants/spacing.module.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';

// Shared header styles from product-details/style.less

.shipping-defaults-header-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: @space-8;
  margin: @space-0 @space-8;
  border-bottom: 1px solid @product-page--header-wrapper--border-color;
}

.shipping-defaults-header-wrapper.dropped {
  padding-top: @space-32;
}

.shipping-defaults-header-text {
  align-self: flex-end;
}

// V3 Inventory tab layout

.inventory-tab {
  padding: @space-0 @space-16 @space-16;
}

.content-card {
  padding: @space-16;
  background: #fff;
  border: 1px solid var(--grey-300);
  border-radius: 4px;
}

.preferences-section {
  padding-bottom: @space-16;
}

.preferences-toggles {
  margin-top: @space-12;
}

.reorder-threshold-row {
  padding-left: @space-36;
}

.reorder-threshold-input {
  width: 100px;
}

.stock-history-row {
  padding: @space-8 @space-0;
}

.icon-wrapper {
  align-self: stretch;
}

.info-icon {
  height: 16px;
  width: 100%;
  vertical-align: middle;
  margin-right: @space-4;
  color: var(--blue-600);
}

.info-text {
  flex: 1 0 0;
}

/* === V3-only: rounded border for grid containers (shared style.less must not be touched).
     Only border-top is added here — children already provide left/right/bottom borders
     from style.less, which overflow:hidden clips to the rounded corners. === */

.inventory-tab :global([class*='locations-container']:not([class*='flex'])),
.inventory-tab :global([class*='allocations-container']) {
  border-top: 1px solid var(--grey-300);
  border-radius: @space-4;
  overflow: hidden;
  margin-bottom: @space-16;
}

/* Remove top border from header rows — they have border: 1px (all sides) from style.less,
   which doubles the container's border-top. */
.inventory-tab :global([class*='locations-container']:not([class*='flex'])) :global([class*='locations-header']),
.inventory-tab :global([class*='allocations-container']) :global([class*='allocations-header']) {
  border-top: none;
}
